import {buildURLBase, getDefaultFilterState} from './queryString'
import {useDispatch, useSelector} from 'react-redux'

import { Button } from '@atd/rui-base.mui.button'
import React from 'react'
import {setJobListFilter} from './workorderActions'

const ResetFilters = () => {
    const adminStore = useSelector(store => store.admin)
    const {selectedCompanyId} = adminStore
    const dispatch = useDispatch()

    const resetFilters = () => {
        const url = buildURLBase()
        window.history.pushState({path: url}, '', url)
        const defaultState = getDefaultFilterState()
        defaultState.selectedCompanyId = selectedCompanyId
        dispatch(setJobListFilter(defaultState, null))
    }

    return (
        <Button variant="contained"
            onClick={resetFilters}
            color="primary"
            className="filterGroup">Reset Filters</Button>
    )
}

export default ResetFilters
